export const handleFilterSelection = store => {
  store.subscribe(mutation => {
    const { payload, type } = mutation

    if (type.split('/')[0] === 'filters') {
      // Keyword Search
      if (type === 'filters/setKeywordSearch') {
        store.commit('queryParams/setKeywordSearch', payload)
      }

      if (type === 'filters/clearSearch') {
        store.commit('queryParams/clearSearch')
      }

      // Locations
      if (type === 'filters/addLocation') {
        store.commit('queryParams/addLocation', payload.filter)
      }

      if (type === 'filters/removeLocation') {
        store.commit('queryParams/removeLocation', payload.filter)
      }

      // Departments
      if (type === 'filters/addDepartment') {
        store.commit('queryParams/addDepartment', payload.filter)
      }

      if (type === 'filters/removeDepartment') {
        store.commit('queryParams/removeDepartment', payload.filter)
      }

      // Teams
      if (type === 'filters/addTeam') {
        store.commit('queryParams/addTeam', payload.filter)
      }

      if (type === 'filters/removeTeam') {
        store.commit('queryParams/removeTeam', payload.filter)
      }

      // Reset all
      if (type === 'filters/reset') {
        store.commit('queryParams/reset')
        store.commit('results/setPageResults', store.getters['results/getResults'])
      }
    }
  })
}
